import { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import * as styled from './styles';

export const DynamicWidthInput = (props) => {
  const {
    className,
    placeholder,
    isValid,
    onKeyUp,
    onKeyPress,
    dataManual,
    size,
    value,
    onChange,
    onFocus,
    onBlur,
    id,
    ariaLabel,
    ariaInvalid,
  } = props;

  const measurer = useRef(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (measurer?.current) {
      const displayValue =
        value && value.trim() !== '' ? value.replace(/ /g, '\u00A0') : '\u00A0';
      measurer.current.textContent = displayValue;
      const rect = measurer.current.getBoundingClientRect();

      if (Math.abs(rect.width - width) > 1) {
        setWidth(rect.width);
      }
    }
  }, [value, placeholder, width]);

  return (
    <>
      <styled.InputSizer ref={measurer}>{value}</styled.InputSizer>
      <styled.Input
        id={id}
        aria-label={ariaLabel}
        aria-invalid={ariaInvalid ? true : undefined}
        style={{ width }}
        className={className}
        value={value}
        placeholder={placeholder}
        isValid={isValid}
        onChange={onChange}
        onKeyUp={onKeyUp}
        onKeyPress={onKeyPress}
        onFocus={onFocus}
        onBlur={onBlur}
        data-manual={dataManual}
        size={size}
      />
    </>
  );
};

DynamicWidthInput.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  ariaLabel: PropTypes.string,
  ariaInvalid: PropTypes.bool,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['small', 'default']),
  isValid: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onKeyUp: PropTypes.func,
  onKeyPress: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  dataManual: PropTypes.string,
};
